import React, { useState } from "react";
import styled from "styled-components";
import GrTitle, { Title } from "../components/BgTitle";
import InputText from "../components/InputText";
import colors from "../constatns/colors";
import useWindowDimensions from "../constatns/size";
import { FiTwitter } from 'react-icons/fi';
import { FaLinkedinIn, FaTelegramPlane } from 'react-icons/fa';
import { ClipLoader } from "react-spinners";
import "../styles/home.css";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";
import SweetAlert from 'react-bootstrap-sweetalert';

function ContactUs() {
    const { width, height } = useWindowDimensions();
    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [companyName, setComanyName] = useState("")
    const [country, setCountry] = useState("")
    const [message, setMessage] = useState("")
    const [isHuman, setIsHuman] = useState(false);
    const [isAlert, setIsAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("Thank you for your message. Email is sent!");
    const [loader, setLoader] = useState(false);

    const sendmail = () => {
        setLoader(true)
        axios.post("https://us-central1-gearchainwebsite.cloudfunctions.net/app/sendemail", {
            email: email,
            userData: {
                name: name,
                companyname: companyName,
                country: country,
                message: message
            }
        }).then((response) => {
            if (response.data.msg === 'success') {
                setEmail("");
                setComanyName("");
                setName("");
                setCountry("");
                setMessage("");
                setIsAlert(true)
                setAlertMessage("Thank you for your message. Email is sent!")

            } else if (response.data.msg === 'fail') {
                setIsAlert(true)
                setAlertMessage("Oops, something went wrong. Try again!");
            }
            setLoader(false)
        }).catch(err => {
            console.log("Error: ", err, "found error!");
        });

    }

    return (
        <div id="contact">
            <GrTitle bgTitle={"CONTACT US"} />
            <Title
                title={"CONTACT US"}
            />
            <Container width={width} height={height} >

                <InnerContainer style={{ display: "block", marginTop: width <= 768 ? 30 : height * 0.1, width: width <= 768 ? "85%" : "50%" }}>
                    <InnerContainer >
                        <InputText
                            title={"Your Name"}
                            value={name}
                            onChange={(text) => { setName(text.target.value) }}
                            placeholder={"John Walton"}
                            inputType={"text"}
                        />
                        <InputText
                            title={"Contact Email"}
                            value={email}
                            onChange={(text) => { setEmail(text.target.value) }}
                            placeholder={"you@example.com"}
                            inputType={"email"}
                        />
                    </InnerContainer>
                    <InnerContainer width={width}>
                        <InputText
                            title={"Company Name"}
                            value={companyName}
                            onChange={(text) => { setComanyName(text.target.value) }}
                            placeholder={"Company Name"}
                            inputType={"text"}
                        />
                        <InputText
                            title={"Country"}
                            value={country}
                            onChange={(text) => { setCountry(text.target.value) }}
                            placeholder={"United States"}
                            inputType={"text"}
                        />
                    </InnerContainer>
                    <InnerContainer width={width}>
                        <InputText
                            title={"Your Message"}
                            value={message}
                            textArea
                            onChange={(text) => { setMessage(text.target.value) }}
                            placeholder={"Type your message..."}
                            inputType={"text"}
                            inputContainerStyle={{ width: "100%" }}
                            inputStyle={{ height: 100, margin: 0 }}
                        />
                        {/* <textarea  /> */}
                    </InnerContainer>
                    <Description style={{ width: "100%" }}>
                        By submitting this form you agree to our terms and conditions and our Privacy Policy which explains how we may collect, use and disclose your personal information including to third parties.
                    </Description>
                    <div style={{ display: width <= 768 ? "block" : "flex", justifyContent: "space-between", marginTop: 20 }}>
                        <ReCAPTCHA
                            sitekey="6LfM7wYgAAAAAI6VleB-WP_Z_vaRAxR_qaTUXxI_"
                            style={{ marginTop: 30 }}
                            onChange={(val) => {
                                setIsHuman(true)
                            }}
                            onError={(err) => {
                                setIsHuman(false)
                            }}
                        />
                        <Btn onClick={() => {
                            if (!isHuman) {
                                setIsAlert(true)
                                setAlertMessage("Verification Required!")
                            }
                            if (isHuman) {
                                sendmail()
                            }
                        }}>
                            {!loader ?
                                "Submit"
                                : <ClipLoader color={colors.white} loading={loader} size={30} />
                            }
                        </Btn>
                    </div>
                </InnerContainer>
                <ImageContainer style={{ position: "relative" }} >
                    <SocialBtnContainer >
                        <InnerContainer>
                            <SocialBtn>
                                <a href="https://twitter.com/gearchainio"
                                    style={{ textDecoration: "none", color: colors.white }}
                                >
                                    <FiTwitter size={'20px'} style={{ marginTop: 5 }} />
                                </a>
                            </SocialBtn>
                            <a href="https://twitter.com/gearchainio"
                                style={{ textDecoration: "none", color: colors.white }}
                            >
                                <Description style={{ fontWeight: "bold", paddingLeft: 10, fontSize: 14, marginTop: 10 }}>Join Us on Twitter</Description>
                            </a>
                        </InnerContainer>


                        <InnerContainer style={{ marginTop: 20 }}>
                            <SocialBtn>
                                <a href="http://t.me/gearchainio"
                                    style={{ textDecoration: "none", color: colors.white }}
                                >
                                    <FaTelegramPlane size={'20px'} style={{ marginLeft: -2, marginTop: 5 }} />
                                </a>
                            </SocialBtn>
                            <a href="http://t.me/gearchainio"
                                style={{ textDecoration: "none", color: colors.white }}
                            >
                                <Description style={{ fontWeight: "bold", paddingLeft: 10, fontSize: 14, marginTop: 10 }}>Join Us on Telegram</Description>
                            </a>
                        </InnerContainer>
                        {/* LinkedIn Icon is added  */}
                        <InnerContainer style={{ marginTop: 20 }}>
                            <SocialBtn>
                                <a href="https://www.linkedin.com/company/gearapp-inc"
                                    style={{ textDecoration: "none", color: colors.white }}
                                >
                                    <FaLinkedinIn size={'20px'} style={{ marginLeft: -2, marginTop: 5 }} />
                                </a>
                            </SocialBtn>
                            <a href="https://www.linkedin.com/company/gearapp-inc"
                                style={{ textDecoration: "none", color: colors.white }}
                            >
                                <Description style={{ fontWeight: "bold", paddingLeft: 10, fontSize: 14, marginTop: 10 }}>Join Us on LinkedIn</Description>
                            </a>
                        </InnerContainer>
                        <InnerContainer style={{ marginTop: 20 }}>
                            <SocialBtn>
                                <a href="https://blog.gearchain.io/"
                                    style={{ textDecoration: "none", color: colors.white }}
                                >
                                    {/* <FaTelegramPlane size={'20px'} style={{marginLeft: -2, marginTop: 5}}/> */}
                                    <img style={{ marginTop: 5, width: 30, height: 30, marginLeft: -5, }} src={require("../assets/images/medium.png")} />
                                </a>
                            </SocialBtn>
                            <a href="https://blog.gearchain.io/"
                                style={{ textDecoration: "none", color: colors.white }}
                            >
                                <Description style={{ fontWeight: "bold", paddingLeft: 10, fontSize: 14, marginTop: 10 }}>Join Us on Blog</Description>
                            </a>
                        </InnerContainer>
                    </SocialBtnContainer>
                    <GlobeImg width={width} alt="Globe" src={require("../assets/images/globe.png")} />
                </ImageContainer>
            </Container>

            {isAlert &&
                <SweetAlert
                    title={"GearChain says!"}
                    onConfirm={() => setIsAlert(false)}
                    onCancel={() => setIsAlert(false)}
                    dependencies={["Thank you for your message. Email is sent!"]}
                    confirmBtnStyle={{ padding: 10, textDecoration: "none", color: colors.btnPrimary }}
                    confirmBtnText={"Confirm"}
                >
                    {alertMessage}
                </SweetAlert>
            }

        </div>
    );
}

const Container = styled.div`
    display: flex;
    padding-left: ${({ width }) => width * 0.1}px;
    justify-content: space-between;
    margin-bottom: 30px;

    @media (max-width: 768px) {
        flex-direction: column;
        margin-bottom: 4rem;
        /* align-items:  center; */
    }

`

const InnerContainer = styled.div`
    display: flex;
    color: ${colors.white};
    justify-content: space-between;
    /* width: 50%; */

`

const SocialBtnContainer = styled.div`
    position: absolute;
    top: 39%;
    left: 25%;
    z-index: 1;

    @media (max-width: 768px) {
        top: 29%;
    }
`

const ImageContainer = styled.div`
    margin-top: ${({ height }) => height * 0.05}px ;
    color: ${colors.white};

    @media (max-width: 768px) {
        align-self: center;
        margin-left: -70px;

    }

`

const GlobeImg = styled.img`
    width: ${({ width }) => width / 2.5}px;
    height: ${({ width }) => width / 2}px;
    opacity: 0.3;

    @media (max-width: 768px) {
        width: ${({ width }) => width / 2}px;
        height: ${({ width }) => width / 1.5}px;
        align-items: center;
        margin-top: 30px;
    }
`

const Btn = styled.button`
    border: 0px;
    background-color: ${colors.btnPrimary};
    color: ${colors.white};
    width: 140px;
    padding: 10px 30px;
    font-size: 18px;
    height: 60px;
    margin-top: 30px;
    border-radius: 5px;

`

const Description = styled.p`
    font-size: 12px;
    color: ${colors.grey};
    width: 200px;
    z-index: 1;

`

const SocialBtn = styled.button`
    display: flex;
    border: 0px;
    background-color: ${colors.socialGreyDark};
    opacity: 0.9;
    width: 35px;
    height: 35px;
    align-items: center;
    color: ${colors.white};
    z-index: 1;
    padding: 8px 8px;
    border-radius: 100%;

    @media (max-width: 768px) {
        align-self: center;
        margin-left: -30px;

    }
`

export default ContactUs;
